import React from 'react';
import styled from 'styled-components';
import { ReactComponent as QuestionIcon } from 'assets/question-circle-solid.svg';
import HasRole from './HasRole';
import { WRITE_ACCESS_AUTH_ROLES } from 'utils/appConstants';
import ReactTooltip from 'react-tooltip';

const StyledQuestionIcon = styled(QuestionIcon)`
  height: ${({ showSmallIcon }) => (showSmallIcon ? '15px' : '25px')};
  color: #bababa;
  margin-left: 10px;
`;

export const StyledButtonsRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${({ justifyContent }) =>
    justifyContent ? justifyContent : 'flex-start'};
`;

const StyledQuestionRow = styled.div`
  display: flex;
`;

const QuestionIconWithWriteAccess = HasRole(
  StyledQuestionIcon,
  WRITE_ACCESS_AUTH_ROLES
);

export const TooltipRow = ({
  disabled,
  display,
  justifyContent,
  message,
  children,
  showSmallIcon
}) => {
  return (
    <StyledButtonsRow justifyContent={justifyContent}>
      {(disabled || display) && (
        <ReactTooltip effect="solid">{message}</ReactTooltip>
      )}
      {children}
      <StyledQuestionRow data-tip="React-tooltip">
        {(disabled || display) && (
          <QuestionIconWithWriteAccess showSmallIcon={showSmallIcon} />
        )}
      </StyledQuestionRow>
    </StyledButtonsRow>
  );
};

export const ShowTooltipOnChildren = ({ showTooltip, message, children }) => {
  return (
    <>
      {showTooltip && (
        <ReactTooltip effect="solid" id={message}>
          {message}
        </ReactTooltip>
      )}
      <div data-tip="React-tooltip" data-for={message}>
        {children}
      </div>
    </>
  );
};
